import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

// Async Thunk: load FAQ data
export const fetchFaqData = createAsyncThunk(
  "faq/fetchFaqData",
  async (params, { rejectWithValue }) => {
    try {
      const safeParams = params ?? {};

      const response = await agent.get(API.FAQ_PAGE, {
        params: safeParams,
      });

      return response?.data?.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error?.message || "Failed to fetch FAQs"
      );
    }
  }
);

const faqSlice = createSlice({
  name: "faq",
  initialState: {
    faqData: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearFaqData: (state) => {
      state.faqData = [];
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFaqData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchFaqData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.faqData = action.payload || [];
      })
      .addCase(fetchFaqData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to load FAQ";
      });
  },
});

export default faqSlice.reducer;
